import React, { useId } from 'react';

import type { InspirationCardProps } from 'src/components/molecules/InspirationCard/InspirationCard';
import { InspirationCard } from 'src/components/molecules/InspirationCard/InspirationCard';
import * as styles from './InspirationListing.styles';

export interface InspirationListingProps {
  heading: string;
  posts: InspirationCardProps[];
}

/** Renders the posts it is given, with no placeholders for a short row. */
export const InspirationListing = ({ heading, posts }: InspirationListingProps) => {
  const headingId = useId();

  return (
    <section aria-labelledby={headingId}>
      <h2 css={styles.heading} id={headingId}>
        {heading}
      </h2>
      <ul css={styles.grid}>
        {posts.map((post) => (
          <li key={post.href}>
            <InspirationCard {...post} />
          </li>
        ))}
      </ul>
    </section>
  );
};
